import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PlaybackControls = ({ 
  isPlaying = false,
  onPlayPause,
  onSkipBackward,
  onSkipForward,
  onPrevious,
  onNext,
  playbackSpeed = 1.0,
  onSpeedChange
}) => {
  const speedOptions = [0.5, 0.75, 1.0, 1.25, 1.5, 2.0];

  const cycleSpeed = () => {
    const currentIndex = speedOptions?.indexOf(playbackSpeed);
    const nextIndex = (currentIndex + 1) % speedOptions?.length;
    onSpeedChange(speedOptions?.[nextIndex]);
  };

  return (
    <div className="playback-controls flex items-center justify-center gap-4">
      <Button
        variant="ghost"
        size="icon"
        onClick={cycleSpeed}
        className="text-muted-foreground hover:text-foreground"
        aria-label={`Скорость воспроизведения: ${playbackSpeed}x`}
      >
        <span className="text-sm font-mono font-medium">{playbackSpeed}x</span>
      </Button>

      <Button
        variant="ghost"
        size="icon"
        onClick={onPrevious}
        aria-label="Предыдущий трек"
      >
        <Icon name="SkipBack" size={24} color="var(--color-foreground)" />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        onClick={onSkipBackward}
        aria-label="Перемотать на 15 секунд назад"
      >
        <Icon name="RotateCcw" size={20} color="var(--color-foreground)" />
      </Button>

      <Button
        variant="default"
        size="lg"
        onClick={onPlayPause}
        className="w-16 h-16 rounded-full"
        aria-label={isPlaying ? 'Пауза' : 'Воспроизвести'}
      >
        <Icon 
          name={isPlaying ? 'Pause' : 'Play'} 
          size={28} 
          color="var(--color-primary-foreground)" 
        />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        onClick={onSkipForward}
        aria-label="Перемотать на 15 секунд вперед"
      >
        <Icon name="RotateCw" size={20} color="var(--color-foreground)" />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        onClick={onNext}
        aria-label="Следующий трек"
      >
        <Icon name="SkipForward" size={24} color="var(--color-foreground)" />
      </Button>
    </div>
  );
};

export default PlaybackControls;